export function createPage(name, slug, layout, components = [], style = '') {
  return {
    name,
    slug,
    layout,
    components,
    style,
  };
}
